"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderElementFontFaceCss = void 0;
const helpers_1 = require("../helpers");
/**
 * Generates @font-face css for rendering selected fonts and font varients of header elements
 * @param usedFonts Fonts used in the epub
 * @param isPreviewer whether the css are for previewer
 * @returns css for the fonts passed as inputs
 */
const getHeaderElementFontFaceCss = (usedFonts, isPreviewer) => {
    let fontCss = "";
    usedFonts.map(usedFont => {
        fontCss += (0, helpers_1.getFontFaceCss)(usedFont, isPreviewer);
    });
    return fontCss;
};
exports.getHeaderElementFontFaceCss = getHeaderElementFontFaceCss;
